import { ParentTree, PostTestResults } from '@holmescorp/lcc-state/interfaces';
import has from '@dojo/framework/core/has';

export const getTestResultScore = (
	tree: ParentTree,
	ditaroots: string[],
	practiceType: string,
	fullPosttest?: PostTestResults
) => {
	const tgfkeys = Object.keys(tree).filter((k) => tree[k].parent !== null);
	const has_scores = () => {
		const roots: string[] = ditaroots;
		return roots.some((k) => tree[k].data.percent > 0);
	};

	const hasTestResults = (tgfkeys.length > 0 || has('use-alternate-pass-view')) && has_scores();
	let score = -1;

	if (practiceType === 'posttest') {
		score = hasTestResults ? fullPosttest?.score || 0 : -1;
	} else {
		const points = Object.keys(tree).reduce(
			(accum, key) => {
				if (tree[key].parent === null) {
					accum.correct += tree[key].data.pointscorrect;
					accum.incorrect += tree[key].data.pointsincorrect;
				}
				return accum;
			},
			{
				correct: 0,
				incorrect: 0
			}
		);
		score = hasTestResults ? (points.correct / (points.correct + points.incorrect)) * 100 : -1;
	}

	return { score, hasTestResults };
};
